export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Map: any;
};

export enum DataFormat {
  Single = 'SINGLE',
  Series = 'SERIES'
}

export type EntitiesResponse = {
  __typename?: 'EntitiesResponse';
  name?: Maybe<Scalars['String']>;
  entities: Array<Entity>;
  totalPageCount: Scalars['Int'];
  totalRowCount: Scalars['Int'];
};

export type Entity = {
  __typename?: 'Entity';
  id: Scalars['ID'];
  name: Scalars['String'];
  icon?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  dataJson: Scalars['String'];
};

export type EntityRequest = {
  name?: Maybe<Scalars['String']>;
  entity: Scalars['String'];
  entityIds?: Maybe<Array<Scalars['String']>>;
  sortBy?: Maybe<MeasureRequest>;
  limit?: Maybe<Scalars['Int']>;
  pageNumber?: Maybe<Scalars['Int']>;
  filters?: Maybe<Scalars['Map']>;
  selection?: Maybe<Scalars['String']>;
};

export enum FilterType {
  None = 'NONE',
  Scope = 'SCOPE',
  Entity = 'ENTITY',
  All = 'ALL'
}


export type MeasureRequest = {
  measureName: Scalars['String'];
  filters?: Maybe<Scalars['Map']>;
  ignore?: Maybe<FilterType>;
};

export type Query = {
  __typename?: 'Query';
  /** Gets generic view data */
  view?: Maybe<ViewResponse>;
};


export type QueryViewArgs = {
  request: ViewRequest;
};

export type Scope = {
  entityName: Scalars['String'];
  entityId: Scalars['String'];
};

export enum Selection {
  Top = 'TOP',
  Bottom = 'BOTTOM',
  Individual = 'INDIVIDUAL',
  Grouped = 'GROUPED'
}

export type ViewMetadata = {
  __typename?: 'ViewMetadata';
  measure: Scalars['String'];
  type: Scalars['String'];
  link?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  format?: Maybe<Scalars['String']>;
};

export type ViewRequest = {
  entities: Array<EntityRequest>;
  measures: Array<MeasureRequest>;
  pageFilters?: Maybe<Scalars['Map']>;
  scope?: Maybe<Scope>;
  dataFormat?: Maybe<DataFormat>;
};

export type ViewResponse = {
  __typename?: 'ViewResponse';
  entitiesResponse: Array<Maybe<EntitiesResponse>>;
  viewMetadata: Array<Maybe<ViewMetadata>>;
};
